/* eslint-disable react/prop-types */
import Flag from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { token } from '@atlaskit/tokens';
import { FlagComponentProps } from './FlagTypes';

const OrgOwnedAccountErrorFlag: React.FC<FlagComponentProps> = ({
  onDismiss,
}) => {
  return (
    <Flag
      icon={
        <ErrorIcon
          label="Error"
          primaryColor={token('color.background.danger.bold')}
        />
      }
      appearance="normal"
      id={'OrgOwnedAccountErrorFlag'}
      onDismissed={onDismiss}
      title={'Unable to link account'}
      description={
        'This email is managed by a company or organization. Enter a personal account instead.'
      }
      actions={[{ content: 'Learn More' }]}
    />
  );
};

export default OrgOwnedAccountErrorFlag;
